<template>
  <div class="the-news-create" v-loading.fullscreen="loading">
    <el-row type="flex" align="middle">
      <el-col :span="12">
        <h3>Добавити новину</h3>
      </el-col>
      <el-col :span="12" class="the-news-create__actions">
        <el-button
          type="primary"
          size="small"
          :disabled="!postEmpty"
          icon="el-icon-circle-check"
          @click="addPost">Зберегти</el-button>
        <el-button
          type="danger"
          size="small"
          plain
          icon="el-icon-circle-close"
          @click="$router.push('/news')">Скасувати</el-button>
      </el-col>
    </el-row>

    <el-input
      class="the-news-create__title"
      v-model="post.title"
      placeholder="Заголовок новини"></el-input>

    <div class="the-news-create__editor" ref="editor"></div>

    <p>Найкраще підійде зображення розміром 1200x400 пікселів</p>

    <el-upload
      class="the-news-create__upload"
      action=""
      :http-request="addAttachment"
      :file-list="attachments"
      :show-file-list="false">
      <el-button
        size="small"
        type="primary"
        icon="el-icon-picture">Завантажити зображення</el-button>
      <el-button
        type="danger"
        size="small"
        plain
        :disabled="post.previewPicture === 'default'"
        icon="el-icon-document-delete"
        @click.stop="removePicture">Видалити зображення</el-button>
      <div slot="tip" class="el-upload__tip">Розмiр не бiльше 5 мб</div>
    </el-upload>

    <img
      v-if="post.previewPicture !== 'default'"
      class="the-news-create__preview-picture"
      :src="post.previewPicture"
      alt="">

    <h4>Банер:</h4>
    <div class="the-news-create__banner" ref="banner"></div>

    <p>&nbsp;</p>
  </div>
</template>

<script>
/**
 * Component: the-news-create - Компонент добавления новости
 *
 * @version 1.0.0
 */

import {
  apiSetImagePreview,
  apiPostNews,
  apiGetNewsPost,
} from '@/api';
import { encodeImage } from '@/util';
import { Auth } from 'aws-amplify';
import { mapGetters } from 'vuex';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

export default {
  name: 'the-news-create',

  data() {
    return {
      post: {
        title: '',
        content: '',
        previewPicture: 'default',
        bannerContent: '',
      },
      attachments: [],
      postEditor: null,
      bannerEditor: null,
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      user: 'user/user',
    }),
    postEmpty() {
      console.log(this.post.title);
      console.log(this.post.content);
      return Boolean(this.post.title && this.post.content);
    },
  },

  mounted() {
    this.initEditor();
  },

  methods: {
    initEditor() {
      this.postEditor = new Quill(this.$refs.editor, {
        theme: 'snow',
      });
      this.bannerEditor = new Quill(this.$refs.banner, {
        theme: 'snow',
      });

      this.postEditor.on('text-change', this.handleUserEditorInput);
      this.bannerEditor.on('text-change', this.handleUserBannerInput);

      this.editMode();
      this.loading = false;
    },

    async getToken() {
      const userSession = await Auth.userSession(this.user);
      return userSession.accessToken.jwtToken;
    },

    removePicture() {
      this.post.previewPicture = 'default';
    },

    async addAttachment(files) {
      const token = await this.getToken();
      const image = await encodeImage(files.file);
      const maxSize = 5e+6; // 5mb

      if (files.file.size > maxSize) {
        this.$message({
          type: 'warning',
          message: 'Файл дуже великий. Будь ласка, добавьте фото меншого розмiру.',
        });
      } else {
        try {
          const imageHash = image.split(',')[1];
          const response = await apiSetImagePreview(token, { image: imageHash });

          if (response.status === 200) {
            this.post.previewPicture = response.data.imageUrl;
          }
        } catch (e) {
          console.log(e);
        }
      }
    },

    async addPost() {
      const token = await this.getToken();
      this.loading = true;

      if (this.postEmpty) {
        try {
          const { status } = await apiPostNews(token, this.post);

          if (status === 200) {
            this.$router.push('/news');
          }
        } catch (e) {
          console.log(e);
        }
      }
    },

    handleUserEditorInput() {
      if (this.postEditor.getLength() > 1) {
        this.post.content = this.postEditor.root.innerHTML;
      } else {
        this.post.content = '';
      }
    },

    handleUserBannerInput() {
      if (this.bannerEditor.getLength() > 1) {
        this.post.bannerContent = this.bannerEditor.root.innerHTML;
      } else {
        this.post.bannerContent = '';
      }
    },

    async editMode() {
      const postId = this.$route.query.id;
      this.loading = true;

      if (postId) {
        /* eslint-disable */
        const token = await this.getToken();
        const { data } = await apiGetNewsPost(token, postId);
        const { _id, title, content, previewPicture, bannerContent = '' } = data.post;

        this.post.title = title;
        this.post.content = content;
        this.post.previewPicture = previewPicture;
        this.post.bannerContent = bannerContent;
        this.post._id = _id;

        this.postEditor.root.innerHTML = content;
        this.bannerEditor.root.innerHTML = bannerContent;
        this.loading = false;
        /* eslint-enable */
      }
    },
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.the-news-create {
  $this: &;
  padding-bottom: $vp * 2;

  &__title {
    margin-bottom: $vp;
  }
  &__actions {
    text-align: right;
  }
  &__editor {
    min-height: 300px;
    max-height: 50vh;
  }
  &__upload {
    margin-top: $vp;
    margin-bottom: $vp;
    max-width: 500px;
  }
  &__preview-picture {
    max-width: 100%;
  }
  &__banner {
    height: 200px;
  }
}
</style>
